import React from 'react';
import { Button, Card, Text } from '@fragments';
import {
    IconArrowDownLeft,
    IconArrowUpRight,
    IconCalendarCheck,
    IconChartBar,
    IconChevronDown,
} from '@tabler/icons-react';
import './styles.scss';

const KPIS = [
    { label: 'Income', value: '$96,000.00', delta: '+5%', trend: 'up', Icon: IconArrowDownLeft },
    { label: 'Expenses', value: '$24,000.00', delta: '-3%', trend: 'down', Icon: IconArrowUpRight },
    { label: 'Scheduled', value: '$14,000.00', Icon: IconCalendarCheck },
];

const BARS = [
    [42, 24, 12],
    [12, 30, 20],
    [54, 28, 18],
    [36, 18, 10],
    [38, 22, 8],
    [42, 18, 10],
    [44, 20, 10],
    [40, 28, 16],
    [34, 24, 14],
    [37, 31, 17],
    [45, 27, 13],
    [55, 35, 20],
];

const MONTHS = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'];

export default function BudgetOverview() {
    return (
        <Card
            flat
            headerDivider
            title="Budget Overview"
            icon={<IconChartBar />}
            action={
                <div className="budget-overview__action">
                    <span className="budget-overview__legend budget-overview__legend--scheduled">Scheduled</span>
                    <span className="budget-overview__legend budget-overview__legend--expenses">Expenses</span>
                    <span className="budget-overview__legend budget-overview__legend--income">Income</span>
                    <Button variant="text" color="inverse" size="small" endIcon={<IconChevronDown />}>
                        Last Year
                    </Button>
                </div>
            }
        >
            <div className="budget-overview">
                <div className="budget-overview__kpis">
                    {KPIS.map(({ label, value, delta, trend, Icon }) => (
                        <div className="budget-overview__kpi" key={label}>
                            <span className="budget-overview__kpi-icon">
                                <Icon />
                            </span>
                            <div>
                                <Text.subheading contrast={6}>{label}</Text.subheading>
                                <div className="budget-overview__value-row">
                                    <Text.h5 weight={500} contrast={10}>{value}</Text.h5>
                                    {delta && (
                                        <span className={`budget-overview__delta budget-overview__delta--${trend}`}>
                                            {delta}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="budget-overview__chart">
                    <div className="budget-overview__axis">
                        <Text.caption contrast={6}>60K</Text.caption>
                        <Text.caption contrast={6}>45K</Text.caption>
                        <Text.caption contrast={6}>30K</Text.caption>
                        <Text.caption contrast={6}>15K</Text.caption>
                        <Text.caption contrast={6}>0</Text.caption>
                    </div>

                    <div className="budget-overview__bars">
                        {BARS.map(([income, expenses, scheduled], index) => (
                            <div className="budget-overview__bar-wrap" key={`${MONTHS[index]}-${index}`}>
                                <div className="budget-overview__bar">
                                    <span className="budget-overview__bar-bg" />
                                    <span className="budget-overview__bar-seg budget-overview__bar-seg--scheduled" style={{ height: `${scheduled}%` }} />
                                    <span className="budget-overview__bar-seg budget-overview__bar-seg--expenses" style={{ height: `${expenses}%` }} />
                                    <span className="budget-overview__bar-seg budget-overview__bar-seg--income" style={{ height: `${income}%` }} />
                                </div>
                                <Text.caption contrast={6}>{MONTHS[index]}</Text.caption>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Card>
    );
}
